"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _Label = _interopRequireDefault(require("../Label/Label"));

require("./Switch.scss");

var _uuid = _interopRequireDefault(require("uuid"));

var _excluded = ["type", "value", "label", "hideLabel", "hasError", "isReversed", "isJustified", "onChange", "selectedValue", "name", "showVisualAid", "disabled", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  /** The label describing the radio/checkbox */
  label: _propTypes.string.isRequired,

  /** Type of HTML tag */
  type: (0, _propTypes.oneOf)(['radio', 'checkbox']),

  /** The name is used to group radios. */
  name: _propTypes.string,

  /** Visually hide the label */
  hideLabel: _propTypes.bool,

  /** Visual presentation of an hasError in the input */
  hasError: _propTypes.bool,

  /** Reverse the visual order of text and switch */
  isReversed: _propTypes.bool,

  /** Force text and switch to opposite sides */
  isJustified: _propTypes.bool,

  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop */
  id: _propTypes.string,
  value: _propTypes.string,

  /** Make a switch disabled*/
  disabled: _propTypes.bool,

  /** Callback function */
  onChange: _propTypes.func,

  /** - When using switches as radio buttons, it takes the value of the selected radio.
   * - If you are using a switch as checkbox it takes a boolean value (true/false)
   * */
  selectedValue: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),

  /** Displays I/O as a visual cue to show if the switch is switched on or off */
  showVisualAid: _propTypes.bool,

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  type: 'checkbox'
};
/** The Switch is a visual representation of an option being true or false. It can have the behaviour of a checkbox or a radio button. */

var Switch = /*#__PURE__*/function (_Component) {
  _inherits(Switch, _Component);

  var _super = _createSuper(Switch);

  function Switch(props) {
    var _this;

    _classCallCheck(this, Switch);

    _this = _super.call(this, props);
    _this.switchId = props.id || "rds-switch-".concat(_uuid.default.v4());
    return _this;
  }

  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          value = _this$props.value,
          label = _this$props.label,
          hideLabel = _this$props.hideLabel,
          hasError = _this$props.hasError,
          isReversed = _this$props.isReversed,
          isJustified = _this$props.isJustified,
          onChange = _this$props.onChange,
          selectedValue = _this$props.selectedValue,
          name = _this$props.name,
          showVisualAid = _this$props.showVisualAid,
          disabled = _this$props.disabled,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var componentClassNames = (0, _classnames.default)('rds-switch', {
        'rds-switch--has-visual-aid': showVisualAid,
        'rds-switch--is-disabled': disabled,
        'rds-switch--is-reversed': isReversed,
        'rds-switch--is-justified': isJustified,
        'rds-switch--has-error': hasError,
        'rds-switch--hide-label': hideLabel
      }, className);

      var isChecked = function isChecked() {
        if (type === 'radio') {
          return selectedValue === value;
        } else {
          return selectedValue;
        }
      };

      return /*#__PURE__*/_react.default.createElement(_Label.default, {
        className: componentClassNames,
        labelText: label,
        htmlFor: this.switchId
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        type: type,
        name: name,
        value: value,
        onChange: onChange,
        checked: isChecked(),
        id: this.switchId,
        disabled: disabled,
        "aria-invalid": hasError
      }, rest)), /*#__PURE__*/_react.default.createElement("span", {
        className: "rds-switch__slider"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rds-switch__knob"
      })));
    }
  }]);

  return Switch;
}(_react.Component);

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
var _default = Switch;
exports.default = _default;